export default __webpack_public_path__ + "static/media/doc-magnet-finder-min.ffc94a1b.png";